module.exports = __webpack_public_path__ + "42122815e115659a41ba8cb6fee8cd35.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/meetup-logo.svg
// module id = 5
// module chunks = 0